module.exports = __webpack_public_path__ + "static/media/ph_testing_video_still.e97280e6.svg";